import * as TYPE from './actionType.js';

export function guardData(guardData) {
  return { type: TYPE.GUARDDATA, data: guardData };
}
